import {
  Box,
  Typography,
  withStyles,
  InputBase,
  Select,
  MenuItem,
} from "@material-ui/core";
import { makeStyles } from "@material-ui/core";
import { useState } from "react";
import { useEffect } from "react";
import { useDataProvider } from "react-admin";

const useStyles = makeStyles((theme) => ({
  container: {
    width: "100%",
    display: "grid",
    gridTemplateColumns: "150px auto",
    alignItems: "center",
    marginTop: 15,
    marginBottom: 15,
  },
}));

const BootstrapInput = withStyles((theme) => ({
  root: {
    "label + &": {
      marginTop: theme.spacing(3),
    },
  },
  input: {
    borderRadius: 4,
    position: "relative",
    backgroundColor: theme.palette.background.paper,
    border: "1px solid #ced4da",
    fontSize: 16,
    padding: "10px 26px 10px 12px",
    transition: theme.transitions.create(["border-color", "box-shadow"]),
    // Use the system font instead of the default Roboto font.
    fontFamily: [
      "-apple-system",
      "BlinkMacSystemFont",
      '"Segoe UI"',
      "Roboto",
      '"Helvetica Neue"',
      "Arial",
      "sans-serif",
      '"Apple Color Emoji"',
      '"Segoe UI Emoji"',
      '"Segoe UI Symbol"',
    ].join(","),
    "&:focus": {
      borderRadius: 4,
      borderColor: "#80bdff",
      boxShadow: "0 0 0 0.2rem rgba(0,123,255,.25)",
    },
  },
}))(InputBase);

const ProductInput = (props) => {
  const classes = useStyles();
  const dataProvider = useDataProvider();
  const [result, setResult] = useState();
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState();
  const [selection, setSelection] = useState();
  // let {
  //   input: { onChange },
  //   //meta: { touched, error },
  // } = useField("product_id");

  useEffect(() => {
    dataProvider
      .getList("products", {})
      .then(({ data }) => {
        setResult(data);
        setLoading(false);
      })
      .catch((error) => {
        setError(error);
        setLoading(false);
      });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleChange = (event) => {
    setSelection(event.target.value);
  };

  if (loading) return null;
  if (error) return null;
  return (
    <Box className={classes.container}>
      <Typography variant="h6">Product name</Typography>
      <Select
        labelId="customized-select-label"
        id="customized-select"
        value={selection}
        onChange={handleChange}
        input={<BootstrapInput />}
      >
        {result.map((d) => {
          return <MenuItem value={d.id}>{d.name}</MenuItem>;
        })}
      </Select>
    </Box>
  );
};

export default ProductInput;
